import { primitiveTokens, semanticThemeTokens } from "@appretio/ui-kit";
import { style } from "@vanilla-extract/css";

export const transparency = style({
  fontSize: primitiveTokens.type.xs
});

export const transparencySummary = style({
  cursor: "pointer",
  opacity: 0.7
});

/** Header row of the expanded pane — hosts the Copy button. */
export const transparencyActions = style({
  display: "flex",
  justifyContent: "flex-end",
  marginTop: primitiveTokens.sizing["2x"]
});

export const transparencyPayload = style({
  maxHeight: "12rem",
  overflow: "auto",
  margin: 0,
  marginTop: primitiveTokens.sizing["2x"],
  padding: primitiveTokens.sizing["2x"],
  borderRadius: primitiveTokens.sizing["1x"],
  border: `1px solid ${semanticThemeTokens.divider.backgroundColor}`,
  whiteSpace: "pre-wrap",
  wordBreak: "break-word"
});
